export const APP_VERSION = '1.14.2'
// ROLLBAR
export const ROLLBAR_API_TOKEN = '26c2890d181743d5b3ac74f87ca508c3'
